import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {NzModule} from '../../nz.module'
import {SystemUpdatesListComponent} from './system-updates-list.component'
import {SystemUpdatesPanelComponent} from './system-updates-panel.component'

@NgModule({
  declarations: [
    SystemUpdatesListComponent,
    SystemUpdatesPanelComponent
  ],
  imports: [
    CommonModule,
    NzModule
  ],
  exports: [
    SystemUpdatesListComponent,
    SystemUpdatesPanelComponent
  ]
})
export class SystemUpdatesModule {
}
